import React, { useEffect, useState } from 'react';
import { useTable } from 'react-table';
import {
  useNavigate,
  useLocation
} from 'react-router-dom';
import styles from '../styles/Links.module.css';


var BatchName = 'Default'

const Table = ({ columns, data }) => {

  
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })

  // Render the UI for your table
  return (
    <table {...getTableProps()} className={styles.userTable}>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps()}>{column.render('Header')}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          //console.log(row)
          prepareRow(row)
          // This cycles over all of the links and displays all of them. They do each have a workerType value
          // in them which can be used to select which to display... or how to display them.
          return (
            <tr {...row.getRowProps()}>
            
              {row.cells.map(cell => {
                var Str = ''
                if (cell.value === 'PersonalMultiple') { 
                  Str = <td {...cell.getCellProps()}><b>{cell.render('Cell')}</b></td>
                }
                else {
                    Str = <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                }    
                return Str
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

function MakeLink(input) {
  console.log(input)
  if ( input != null )
  {
    // Make retake link
    var Str = ''
    // Is this local clinic or remote?
    //console.log(window.location)
    var BasePath = window.location.hostname
  // Check to see if a port is needed
  // JATOS runs locally on port 9000
    var PortNumber = ''
    if ( ! window.location.port == "" )
    {
      PortNumber = ':9000'
    }

  /* var LocalFlag 
  if ( BasePath.includes('localhost') )
  { 
    console.log("TRUE")
    LocalFlag = true 
    BasePath =  "http://127.0.0.1:9000/publix/"
  }
  else {
    console.log("FALSE")
    BasePath = "https://jatos.ncmlab.ca/publix/"
  } */
    var Output = window.location.protocol + '//' + BasePath + PortNumber + '/publix/' + input +'?Battery=71&UsageType=Session'
    //console.log(Output)
    return (<div><a href={Output} target="_blank">Link</a></div>)
  }
  else { return <div></div> }
  
}

function GetSelectedBatchName() {
  var BatchName
  BatchName = document.getElementById('SelectedBatch').innerHTML
  if ( BatchName === '' )
  {
    BatchName = "Default"
  }
  //else {
    //console.log("FALSE")
    //console.log("JASON>> " + BatchName)}
  return BatchName
}
//const BatchName = 'NCM_10-23-9755'


//console.log(document.getElementById('SelectedBatch').innerHTML)
//var BatchName = 'Default'

//BatchName = document.getElementById('SelectedBatch').innerHTML
//const BatchName = 'Default'
const Links = ({ setWorker, study}) => {

  const [users, setUsers] = useState(null);
  const [search, setSearch] = useState("");
  const [selectedBatch, setSelectedBatch] = useState();
  const [dataamount, setDataamount] = useState([]);



  
  //fetch(`/get_links/${study.uuid}`)
  useEffect(() => {
    fetch(`/NEWget_all_links/${GetSelectedBatchName()}`)
      .then((response) => response.json())
      .then((data) => {
        const res = [...data].map((e) => {
          var JSONData = e.batchSessionData
          JSONData = JSON.parse(JSONData)
          if ( e.batchSessionData != null )
          { 
            if ( typeof JSONData[e.worker_id] != 'undefined' )
            {
              e.Name = JSONData[e.worker_id+"_FirstName"]
              e.LinkStatus = 'In Use' 
            } 
            else { 
              e.LinkStatus = 'Available' 
            }
          }
          else {
            e.Name = ''
              e.LinkStatus = '' 
          }
          console.log(e)
          return {
            
            code: e.studyCode,
            //date: e.JASONDATE,
            batch: 'empty', //e.title,
            linkCode: MakeLink(e.studyCode),
            //data: FindData(e.worker_id),
            linkStatus: e.LinkStatus,
            name: e.Name,
            email: e.comment,
            worker:e.worker_id,
            workerType: e.workerType,
            actions: <div> 
              <button onClick={() => {
                // This goes through the information return from mySQL and sends some of it to be part of the "worker"
                setWorker({
                  id: e.worker_id,
                  email: e.comment ? e.comment : e.id,
                  studyCode: e.studyCode,
                  workerType: e.workerType
                });
                
              }
              }>View</button>
              {/*{e.worker_id !== 1 && (<button onClick={() => {
                fetch(`/send_test_email/${e.comment}/${e.studyCode}`)
                  .then(() => {
                    alert('Test link sent succesfully.');
                  });
              }}>Send Link</button>)}*/}
            </div>,
            
            
          };
        });
        setUsers(res);
      });
  }, [setWorker, study.uuid]);
  

  
  const columns = React.useMemo(
    () => [
      {
        Header: 'Test',
        columns: [
          /*{
            Header: 'Batch',
            accessor: 'batch',
          },*/
          /*{
            Header: 'Test Start Date/Time',
            accessor: 'date',
          },*/
          {
            Header: 'Worker',
            accessor: 'worker',
          },
          /* {
            Header: 'Worker Type',
            accessor: 'workerType',
          }, */
          {
            Header: 'Actions',
            accessor: 'actions'
          },
          {
            Header: 'Link Status',
            accessor: 'linkStatus'
          },
          {
            Header: 'Links',
            accessor: 'linkCode'
          },
          {
            Header: 'Name',
            accessor: 'name'
          },

        ],
      },
    ],
    []
  )


  if (users === null) return <div className={styles.container}
    style={{ fontSize: "1.5em" }}>
    Loading...
  </div>

  if (users.length === 0) return <div className={styles.container}
    style={{ fontSize: "1.5em" }}>
    No Study Links
  </div>





  return (
    <div className={styles.container}>
      <div>
        <div className={styles.activeLinksHeader}>
          <div className={styles.link}/>
          <h2>Study Links</h2>
          <div>
          
          
          {selectedBatch}
            
          
          </div>
          <div className={styles.searchContainer}>
            <input value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              type="text" placeholder="Search..." />
          </div>

        </div>
        

        <Table columns={columns} data={users.filter((u) => {
          return u.batch.includes(search) ||
            u.code.includes(search) ||
            u.email.includes(search)
        })} />
      </div>
      
    </div>
  );
}

export default Links;